import React, { Component } from "react";

/**
 * 計時器。
 *
 * 剩餘時間是從「結束時刻」反推的，不是每秒減一。
 *
 * 原本的寫法每次 tick 就把計數器減 1，等於假設 setInterval 真的每秒跑一次。
 * 但瀏覽器會把背景分頁的 setInterval 節流到大約一分鐘一次——考生把分頁切到
 * 背景（或最小化視窗、螢幕休眠），計時器就會走得比真實時間慢，離開越久差越多。
 * 記下結束時刻、每次用現在時間去減，不管中間漏跑幾次都算得出正確的剩餘秒數。
 *
 * 另外在回到畫面時立刻重算一次，不必等下一次 tick。
 *
 * startingSeconds 是續考用的：被鎖住解鎖回來時要接著剩下的時間跑，
 * 不是重新給滿。沒給就照原本的 startingMin 從頭算。
 *
 * onTick 每秒回報剩餘秒數，讓上層可以連同答案一起存進度。
 */
class Timer extends Component {
  constructor(props) {
    super(props);
    const total =
      props.startingSeconds !== undefined && props.startingSeconds !== null
        ? Math.max(0, Math.round(props.startingSeconds))
        : props.startingMin * 60;
    this.total = total;
    this.ended = false;
    this.state = {
      hideTime: false,
      minutes: Math.floor(total / 60),
      minutesPlueOne: Math.ceil(total / 60),
      seconds: 60,
      secondsRemaining: total,
    };
  }

  componentDidMount() {
    this.endAt = Date.now() + this.total * 1000;
    this.timer = setInterval(this.tick, 1000);
    document.addEventListener("visibilitychange", this.handleVisibility);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    document.removeEventListener("visibilitychange", this.handleVisibility);
  }

  /** 回到畫面時立刻補算——背景期間 tick 可能一分鐘才跑一次 */
  handleVisibility = () => {
    if (!document.hidden) {
      this.tick();
    }
  };

  tick = () => {
    const remaining = Math.max(0, Math.round((this.endAt - Date.now()) / 1000));
    const min = Math.floor(remaining / 60);
    const sec = remaining - min * 60;

    this.setState(
      {
        minutes: min < 10 ? `0${min}` : min,
        seconds: sec < 10 ? `0${sec}` : sec,
        minutesPlueOne: Math.ceil(remaining / 60),
        secondsRemaining: remaining,
      },
      () => {
        if (this.props.onTick) {
          this.props.onTick(remaining);
        }
        // 只收一次卷。歸零之後計時器還掛在畫面上（結束頁的 banner 也有），
        // 沒有這道閘門就會每秒再喊一次收卷。
        if (remaining <= 0 && !this.ended) {
          this.ended = true;
          this.props.forceEndTest();
        }
      }
    );
  };

  renderTime() {
    if (this.state.hideTime) {
      return <span>Click to show time</span>;
    } else {
      return (
        <span>
          <span className="show-hover">
            <span className="font-big">
              {this.state.minutes}:{this.state.seconds}{" "}
            </span>
            left
          </span>
          <span className="hide-hover">
            <span className="font-big">{this.state.minutesPlueOne} </span>
            minutes left
          </span>
        </span>
      );
    }
  }

  render() {
    const flash =
      ((this.state.secondsRemaining <= 600 &&
        this.state.secondsRemaining >= 596) ||
        (this.state.secondsRemaining <= 300 &&
          this.state.secondsRemaining >= 296)) &&
      !this.state.hideTime
        ? true
        : false;

    return (
      <div className="col col-12 col-md-2 timer">
        <img className="height-control" src="/img/Clock.svg" alt="" />
        <span
          onClick={() => this.setState({ hideTime: !this.state.hideTime })}
          className={`timer-container ${flash ? "flash" : ""} ${
            this.state.secondsRemaining <= 300 && !this.state.hideTime
              ? "red"
              : ""
          }`}
        >
          {this.renderTime()}
        </span>
      </div>
    );
  }
}

export default Timer;
